<template>
    <v-container grid-list-md v-if="sample">
        <v-card-title>
            <v-flex xs12>
                <v-btn v-if="sample.status_id == 4" color="green" dark large>SENT</v-btn>
                <v-btn v-if="sample.status_id == 6" color="red" dark large>CANCELED</v-btn>
            </v-flex>
            <v-flex xs12 class="mt-2">
                <div class="title" v-if="sample.status_id == 4">Tracking number: {{ sample.track_number }}</div>
            </v-flex>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="products.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="items" slot-scope="props" v-if="props.item.sent == 1">
                <td class="text-xs">{{ props.item.lc_code }}</td>
                <td class="text-xs">{{ props.item.name }}</td>
                <td class="text-xs">{{ props.item.quantity }}</td>
                <td class="layout px-0">
                    <FeedbackComponent v-if="sample.status_id == 4" :sample_order_line="props.item" :sample_order_id="sample.id"></FeedbackComponent>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="products.meta">
            <v-pagination
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
        </div>
    </v-container>
</template>

<script>
    import FeedbackComponent from './components/FeedbackComponent';

    export default {
        props: ['sample'],
        data: function () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: false,
                headers: [
                    {
                        text: 'Reference',
                        align: 'left',
                        sortable: false,
                        value: 'code'
                    },
                    { text: 'Sample', value: 'product', sortable: false },
                    { text: 'Quantity', value: 'units', sortable: false },
                    { text: 'Feedback', value: 'pricekg', sortable: false }
                ],
                products: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition'
            }
        },
        created () {
            this.debouncedGetProducts = _.debounce(this.getProducts, 500)
            if (this.sample) {
                this.getProducts();
            }
        },
        watch: {
            sample: function () {
                this.getProducts();
            },
            search: function () {
                this.loading = true;
                this.debouncedGetProducts();
            },
            last_page: function () {
                if (this.page > this.products.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods: {
            setPage (page) {
                this.page = page;
                this.getProducts();
            },
            getProducts () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        id: this.sample.id
                    },
                    id: this.sample.id
                };
                this.$store.dispatch('getSampleOrderLines', params).then((res) => {

                    this.products = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
        },
        components: {
            FeedbackComponent
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/agent/samples/views/InfoComponent.vue